module.exports = __webpack_public_path__ + "img/end2.e7c2b326.svg";